import { render, staticRenderFns } from "./el-skeleton.vue?vue&type=template&id=40e0b6ea"
import script from "./el-skeleton.vue?vue&type=script&lang=js"
export * from "./el-skeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports